/**
 * Choisit le texte des consignes selon la langue demandee.
 * Le francais sert de repli pour garder les regles lisibles
 * lorsque leur traduction manque.
 */
import { TI18nText } from '../../../models/courses/graphicDesign';

/** Retourne la traduction disponible, ou le texte francais. */
export const pickI18n = (value: TI18nText | undefined, lang: string): string => {
  if (!value) return '';
  const code = lang.split('-')[0] as keyof TI18nText;
  const selected = value[code];
  return typeof selected === 'string' && selected.trim() ? selected : value.fr || '';
};
